import type {RootState} from '../store';
import type {BundleProps, StatusType, ReduxAction} from './typings';

import {
  STATUS_IDLE,
  STATUS_LOADING,
  STATUS_SUCCEEDED,
  STATUS_FAILED,
  GET_PRODUCT_BUNDLE_REQUEST,
  GET_PRODUCT_BUNDLE_SUCCESS,
  GET_PRODUCT_BUNDLE_FAILURE,
} from '../actionTypes';

type AddToBundleActionTypes =
  | typeof GET_PRODUCT_BUNDLE_REQUEST
  | typeof GET_PRODUCT_BUNDLE_SUCCESS
  | typeof GET_PRODUCT_BUNDLE_FAILURE;

export interface AddToBundleState {
  status: StatusType;
  data: BundleProps | null;
  error: string | null;
}

export const initialState: AddToBundleState = {
  status: STATUS_IDLE,
  data: null,
  error: null,
};

const productAddToBundleReducer = (
  state = initialState,
  action: ReduxAction<BundleProps, AddToBundleActionTypes>,
) => {
  switch (action.type) {
    case GET_PRODUCT_BUNDLE_REQUEST:
      return {
        ...state,
        status: STATUS_LOADING,
        error: null,
      };

    case GET_PRODUCT_BUNDLE_SUCCESS:
      return {
        ...state,
        status: STATUS_SUCCEEDED,
        data: action.response?.data as BundleProps,
      };

    case GET_PRODUCT_BUNDLE_FAILURE:
      return {
        ...state,
        status: STATUS_FAILED,
        error: action.error?.message as string,
      };

    default:
      return state;
  }
};

export const getProductAddToBundle = (state: RootState) => state.productAddToBundle;

export default productAddToBundleReducer;
